import OnlineClassService from "../../entrypoints/src/admin/services/online-class-service";
import AjaxLoader from "../../entrypoints/src/admin/utilities/ajax-loader";
import MeetController from "./meet_controller";
import OnlineClassroomChannel from "../../entrypoints/src/admin/channels/online_classroom_channel";

export default class extends MeetController {
  static values = {
    roomScreen: String,
    roomName: String,
    displayName: String,
    email: String,
    domain: String,
    token: String,
    appointmentId: String,
    attendanceId: String
  }

  connect() {
    this.initializeMeeting({
      userInfo: {
        email: this.emailValue,
        displayName: this.displayNameValue
      }
    }).then((jitsiApi) => {
      OnlineClassroomChannel.init(this.roomNameValue);
      this.closeScreenOnHangup(jitsiApi);
    });
  }

  closeScreenOnHangup(jitsiApi) {
    jitsiApi.on('readyToClose', async () => {
      AjaxLoader.show();

      jitsiApi.dispose();
      await OnlineClassService.leaves(this.appointmentIdValue, this.attendanceIdValue);
      Turbo.visit(this.element.dataset.url);
    });
  }
}
